// extracted by mini-css-extract-plugin
export default {"spinner":"ModalSpinner_spinner__mHCz9","spin":"ModalSpinner_spin__otHeX"};